<template>
<ValidationObserver class="col" tag="div" ref="form" v-slot="{ invalid, handleSubmit }">
    <Loading />
    <Message />

    <CForm method="post" @submit.prevent="handleSubmit(submit)">
        <CRow>
            <CCustomInput
                col="12" sm="6"
                vid="first_name"
                :name="$t('user.first_name')"
                rules="required"
                required
                v-model="user.first_name"
            />

            <CCustomInput
                col="12" sm="6"
                vid="last_name"
                :name="$t('user.last_name')"
                rules="required"
                required
                v-model="user.last_name"
            />

            <CCustomInput
                col="12"
                vid="phone"
                :name="$t('user.phone')"
                rules="required"
                required
                v-model="user.phone"
                ltr
            />

            <CCustomInput
                col="12"
                vid="email"
                :name="$t('user.email')"
                rules="required|email"
                required
                v-model="user.email"
                ltr
            />

            <CCustomInput
                col="12"
                vid="password"
                :name="$t('user.password')"
                :rules="{required: user.id === undefined}"
                :required="user.id === undefined"
                v-model="user.password"
                password
                ltr
            />

            <CCustomSelect
                col="12"
                vid="role"
                :name="$t('role._')"
                v-model="user.role_id"
                :options="selectableRoles"
                required
                rules="required"
            />
        </CRow>

        <CButton :disabled="invalid" type="submit" color="primary">
            <span v-if="user.id">{{ $t('btn.edit', {attribute: $t('user._')}) }}</span>
            <span v-else>{{ $t('btn.create', {attribute: $t('user._')}) }}</span>
        </CButton>
    </CForm>
</ValidationObserver>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'Form',

    props: {
        submit: {
            default: function() {},
            required: true,
        },
        user: {
            default() {
                return {
                    first_name: '',
                    last_name: '',
                    phone: '',
                    email: '',
                    password: '',
                    role: false
                }
            }
        }
    },

    computed: {
        ...mapGetters({
            selectableRoles: 'role/selectableRoles'
        })
    },
}
</script>